var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.021 22H21.979C23.156 22 23.838 20.636 23.2 19.413L12.721 1.78C12.321 1.061 11.679 1.061 11.279 1.78L0.8 19.413C0.162 20.636 0.844 22 2.021 22ZM13 18C13 18.552 12.552 19 12 19C11.448 19 11 18.552 11 18V17.8C11 17.248 11.448 16.8 12 16.8C12.552 16.8 13 17.248 13 17.8V18ZM11.2 6H12.8C13.04 6 13.171 6.184 13.2 6.485L12.8 14C12.77 14.276 12.552 14.5 12 14.5C11.448 14.5 11.23 14.276 11.2 14L10.8 6.485C10.829 6.184 10.96 6 11.2 6Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.17d4042386b5605628f8989eeaecd4bd.svg";
export { ForwardRef as ReactComponent };